module.exports = __webpack_public_path__ + "static/media/flower-7.01d14aa3.svg";